import { UpgradeMessageContainer } from './UpgradeMessageContainer';
import arrow from './arrow.svg';
import { ArrowRight, Message, NoStyleButton } from './styles';

type Props = {
	message: string;
	onClick?: () => void;
};

export const UpgradeMessage = ({ message, onClick }: Props) => {
	const messageContent = (
		<UpgradeMessageContainer hasArrow={Boolean(onClick)}>
			<Message>{message}</Message>
			{onClick && <ArrowRight src={arrow} alt="#" />}
		</UpgradeMessageContainer>
	);

	if (onClick) {
		return (
			<NoStyleButton type="button" onClick={onClick}>
				{messageContent}
			</NoStyleButton>
		);
	}

	return messageContent;
};
